<script lang="ts">
  import { getTitle } from '$lib/components/title'
  import Container from '$lib/site/Container.svelte'

  import DocsNav from './DocsNav.svelte'

  const { data } = $props()
</script>

<svelte:head>
  <title>{getTitle(data.doc.title, 'Turbomaps Documentation')}</title>
</svelte:head>

<Container nav padding footer>
  <div class="container">
    <DocsNav docs={data.docs} selected={data.doc.filename} />
    <section>
      <h1>{data.doc.title}</h1>
      <div class="prose">
        <!-- eslint-disable-next-line svelte/no-at-html-tags -->
        {@html data.doc.content}
      </div>
    </section>
  </div>
</Container>

<style>
  h1 {
    font-size: 2em;
    margin-top: 0.5em;
    font-weight: 600;
    text-rendering: geometricPrecision;
  }
  @media (min-width: 700px) {
    .container {
      display: grid;
      grid-template-columns: 250px 1fr;
      gap: 2rem;
    }
  }
</style>
